import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { LEFT_CONTAINER_SIZE } from 'App/components/style';
import {DEVICE_BREAKPOINT, MOBILE_HEADER_HEIGHT, TITLES_NORMAL} from "Shared/styles/designConstants";
import styled from 'styled-components';

type AccountSidebarContainerProps = {
  isVisible : boolean,
  isLoggedIn: boolean
}

type AccountContentContainerProps = {
  isVisible: boolean
}

const ACCOUNT_SIDEBAR_WIDTH = '312px';

export const AccountContainer = styled.div`
  display  : flex;
  flex-grow: 1;
`;

export const AccountSidebarContainer = styled.div<AccountSidebarContainerProps>`
  height    : 100vh;
  box-shadow: ${ DESIGN_TOKENS.shadow.xs.value };
  background: ${ DESIGN_TOKENS.color.background.primary.value };
  width     : ${ACCOUNT_SIDEBAR_WIDTH};
  overflow  : auto;
  position  : sticky;
  top       : 0;
  padding   : 0 8px;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    display   : ${ props => props.isVisible ? 'block' : 'none' };
    width     : 100%;
    max-width : none;
    box-shadow: none;
    overflow  : unset;
    position  : unset;
  }
`;

export const AccountContentContainer = styled.div<AccountContentContainerProps>`
  flex     : 1;
  max-width: 100vw;
  position : relative;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    display: ${ props => props.isVisible ? 'block' : 'none' };
    left   : 0;
  }
`;

export const LoggedOutHeaderGap = styled.div`
  @media ${DEVICE_BREAKPOINT.maxMobile} {
    height: ${MOBILE_HEADER_HEIGHT};
  }
`;

export const MobileNavbarContainer = styled.div`
  display: none;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    text-align      : left;
    padding-top     : 0px;
    position        : sticky;
    z-index         : 1;
    width           : 100%;
    text-align      : center;
    vertical-align  : middle;
    line-height     : calc(${MOBILE_HEADER_HEIGHT} - 1px);
    top             : 0;
    margin-top      : -${MOBILE_HEADER_HEIGHT};
    box-shadow      : ${DESIGN_TOKENS.shadow.xs.value};
    background-color: ${DESIGN_TOKENS.color.background.primary.value};
    display         : block;
    text-align      : center;
    z-index         : 199;
  };

  svg {
    color     : ${DESIGN_TOKENS.color.text.normal.value};
    margin-top: -12px;
    position  : absolute;
    height    : 24px;
    width     : 24px;
    left      : 20px;
    top       : 50%;
    cursor    : pointer;
  }
`;

export const MobileNavbarTitle = styled.div`
  display: none;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    ${TITLES_NORMAL.FT_01}
    visibility : visible;
    display    : block;
    font-size  : 18px;
    color      : ${DESIGN_TOKENS.color.text.normal.value};
    text-align : center;
    line-height: 50px;
  }
`;

export const SnackBarContainer = styled.div`
  width          : calc(100% - ${ACCOUNT_SIDEBAR_WIDTH} - ${LEFT_CONTAINER_SIZE});
  display        : flex;
  justify-content: center;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    width      : 100%;
    padding-top: ${MOBILE_HEADER_HEIGHT};
  }
`;